import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useRef, useState } from 'react';
import useStackedBarPlacement from '../../../hooks/useStackedBarPlacement';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const PieDoughnutBarsLegendItem = _ref => {
  let {
    heading,
    text,
    amount,
    maximum,
    color = '',
    containerWidth = 0,
    onClick
  } = _ref;
  const barRef = useRef(null);
  const {
    0: isVisible,
    1: setIsVisible
  } = useState(false);
  const {
    textTransform,
    graphicTransform,
    isReady
  } = useStackedBarPlacement({
    isVisible,
    amount,
    maximum,
    containerRef: barRef,
    containerWidth,
    delay: 350
  });
  return /*#__PURE__*/_jsxs("li", {
    className: styles.item,
    onClick: onClick,
    children: [/*#__PURE__*/_jsx("span", {
      className: styles.text,
      children: heading
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.graphic,
      children: [/*#__PURE__*/_jsx("div", {
        className: styles.bar,
        ref: el => {
          setIsVisible(true);
          barRef.current = el;
        },
        children: isReady ? /*#__PURE__*/_jsx("span", {
          className: styles.barValue,
          style: _objectSpread(_objectSpread({}, color && {
            backgroundColor: color
          }), {}, {
            transform: graphicTransform
          })
        }) : /*#__PURE__*/_jsx("div", {
          className: styles['barValue--loading']
        })
      }), /*#__PURE__*/_jsx("span", {
        className: styles.barAmount,
        style: {
          transform: textTransform
        },
        children: text
      })]
    })]
  });
};

export default PieDoughnutBarsLegendItem;